module.exports = __webpack_public_path__ + "static/media/dilwara temple SMALL AND BIG.5983efb0.png";